import React, { useEffect } from 'react';
import { Popover as PopoverDefault } from 'react-bootstrap';
import { PopoverProps } from 'react-bootstrap/Popover';

type PropsType = PopoverProps & {
  id: string,
  text: React.ReactNode,
  onMouseEnter: () => void,
  onMouseLeave: () => void,
  popper?: any,
}

const Popover = React.forwardRef<any, PropsType>(({
  id,
  text,
  onMouseEnter,
  onMouseLeave,
  popper,
  ...props
}, ref) => {
  useEffect(() => {
    popper.scheduleUpdate();
  }, [text]);

  return (
    <PopoverDefault
      id={id}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      ref={ref}
      {...props}
    >
      <div className="popover__content">
        {text}
      </div>
    </PopoverDefault>
  );
});

export { Popover };
